import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DnaAlertService, DnaAlertMessage } from '../../service/dna-alert.service';

@Component({
  selector: 'dna-alert',
  templateUrl: './dna-alert.component.html',
  styleUrls: ['./dna-alert.component.scss'],
  standalone: false,
})
export class DnaAlertComponent implements OnInit, OnDestroy {
  alert: DnaAlertMessage | null = null;
  private _sub: Subscription;
  private _timer: ReturnType<typeof setTimeout>;

  constructor(private _alertService: DnaAlertService) {}

  ngOnInit(): void {
    this._sub = this._alertService.alert$.subscribe(msg => {
      this.alert = msg;
      clearTimeout(this._timer);
      if (msg) {
        this._timer = setTimeout(() => { this.alert = null; }, 5000);
      }
    });
  }

  dismiss(): void {
    this.alert = null;
    clearTimeout(this._timer);
    this._alertService.clear();
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
    clearTimeout(this._timer);
  }
}
